import { jsx as g } from "react/jsx-runtime";
import { useRef as l, useCallback as H, useEffect as a } from "react";
import '../../assets/BCVideoPlayer.css';function z({
  bcId: t,
  playerElId: n = "bc-player",
  containerClosing: i = !1,
  autoplay: c = !1,
  mute: u = !1,
  handleClosing: h = () => !0,
  pauseVideo: d = !1,
  BC_AID: p = "",
  BC_PLAYERID: f = "",
  BC_EMBEDID: y = ""
}) {
  const r = l(null), s = l(null), m = l(t), P = (e) => {
    e.key === "Escape" && (e.preventDefault(), h(e));
  }, K = (e) => {
    e.key === "Escape" && (e.stopPropagation(), e.preventDefault());
  }, v = H(() => {
    c && r.current.play(), u && r.current.muted(!0);
  }, [c, u]);
  return a(() => {
    const e = () => {
      const w = p, $ = f, x = `<video-js id="${n}" data-video-id="${t}" data-account="${w}" data-player="${$}" data-embed="${y}" controls></video-js>`;
      s.current.innerHTML = x, r.current !== null && r.current.dispose();
      const j = document.getElementById("video-js-script");
      j && j.remove();
      const o = document.createElement("script");
      o.src = `https://players.brightcove.net/${w}/${$}_default/index.min.js`, o.id = "video-js-script", document.body.appendChild(o), o.onload = () => {
        r.current = window.bc(n), r.current.on("loadedmetadata", v), document.querySelector(`#${n}`).focus();
      };
    }, k = setInterval(() => {
      s.current !== null && (clearInterval(k), e());
    }, 100);
  }, [t, n, v, p, f, y]), a(() => {
    i && r.current !== null && r.current.pause();
  }, [i]), a(() => {
    m.current !== t && (m.current = t);
  }, [t]), a(() => {
    var e;
    d && ((e = r.current) == null || e.pause());
  }, [d]), t != null && t !== "" ? /* @__PURE__ */ g(
    "div",
    {
      id: "video-player-wrapper",
      className: "video-player__wrapper",
      onKeyDown: K,
      onKeyUp: P,
      ref: s
    },
    t
  ) : null;
}
export {
  z as BCVideoPlayer,
  z as default
};
